import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { FormBuilder, FormControl, FormGroup, NgFormSelectorWarning } from '@angular/forms';
import { CommonComponents } from 'src/app/Sharedservice/CommonComponents';
import { Router, ActivatedRoute } from '@angular/router';
import { ProceduresService } from 'src/app/Services/NewVisitNote/procedures.service';
import { ToastrService } from 'ngx-toastr';
import { MatDialog, MatTableDataSource, MatPaginator, MatTable, MatDialogRef, MatCheckboxChange, MatSort, MAT_DIALOG_DATA } from '@angular/material';
import { IProcedureCategory, IProceduresAllData, IProcedureParts, IprocedureLevels, IprocedureTypes, IprocedureSides, IprocedureOthers, IprocedureCPTCodes, IProcedureComponent, IProcedureCompDetails } from 'src/app/models/IProcedures';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { ProgressNotesService } from 'src/app/Services/NewVisitNote/progress-notes.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { PatientProceduresComponent } from '../patient-procedures/patient-procedures.component';
import { DialogData } from '../patient-current-encounters/patient-current-encounters.component';
import { ConfirmDialogModel, DeleteDocumentComponent } from 'src/app/PatientChart/Document/delete-document/delete-document.component';

@Component({
  selector: 'app-procedures',
  templateUrl: './procedures-dialog.component.html',
  styleUrls: ['./procedures-dialog.component.css'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ]
})


@Component({
  selector: 'app-procedures-dialog',
  templateUrl: './procedures-dialog.component.html',
  styleUrls: ['./procedures-dialog.component.css']
})
export class ProceduresDialogComponent implements OnInit {

  activetab = 12;
  ProceduresForm: FormGroup;
  submitted = false;
  public show: boolean = false;

  procedureInfo: IProcedureComponent;
  addProcComponent: IProcedureCompDetails;
  procCategorydata: IProcedureCategory[] = [];
  procLevelsdata: IprocedureLevels[] = [];
  procPartsdata: IProcedureParts[] = [];
  procCptsdata: IprocedureCPTCodes[] = [];
  procTypesdata: IprocedureTypes[] = [];
  procSidesdata: IprocedureSides[] = [];
  procOthersdata: IprocedureOthers[] = [];
  ProceduresAllData: IProceduresAllData[] = [];
  selectedProcComponentData: IProcedureComponent;
  proceduresComponent: IProcedureComponent[] = [];
  patientprocedures: IProcedureComponent[] = [];
  pastpatprocedures: IProcedureComponent[] = [];
  Currpatprocedures: IProcedureComponent[] = [];
  VisitNoteprocedures: IProcedureComponent[] = [];
  public selctedProcedureCode: IProcedureComponent;

  dataSource1 = new MatTableDataSource(this.procCategorydata);
  dataSource2 = new MatTableDataSource(this.ProceduresAllData);
  dataSource = new MatTableDataSource(this.proceduresComponent);
  dataSource3 = new MatTableDataSource(this.patientprocedures);
  dataSource4 = new MatTableDataSource();

  filterValues = { dateVisit: '', type: '', side: '', procedureName: '', levels: '', others: '', cptCode: '', qty: '' };
  visitDateFilter = new FormControl('');
  typeFilter = new FormControl('');
  sideFilter = new FormControl('');
  procNameFilter = new FormControl('');
  levelsFilter = new FormControl('');
  othersFilter = new FormControl('');
  cptCodesFilter = new FormControl('');
  qtyFilter = new FormControl('');


  //visitNoteProceduresdataSource = new MatTableDataSource(this.VisitNoteprocedures);
  visitNoteProceduresdataSource = new MatTableDataSource(this.patientprocedures);
  // dataSource = ELEMENT_DATA;
  // dataSource1 = ELEMENT_DATA1;
  // dataSource3 = ELEMENT_DATA22;
  public IsAllProcedures: boolean = true;
  public IsPatientProcedures: boolean = false;
  public selectProcCategory: number = 2;
  public VisitNoteProcedures: boolean = false;
  selectedRowIndex: number = -1;
  oncategoryIndex: number = -1;
  saveflag: boolean = false;
  public result: any;
  popupVisible = false;
  displayedColumns: string[] = ['category'];
  displayedColumnse = ['cptcode', 'Procedureses'];//, 'Actions'];
  displayedColumns2: string[] = ['type', 'side', 'procedure', 'levels', 'steroids', 'cptcode', 'qty'];//, 'action'];
  displayedColumns3: string[] = ['dateVisit', 'type', 'side', 'procedure', 'levels', 'steroids', 'cptcode', 'qty'];//, 'action'];
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild('table', { static: true }) table: MatTable<IProcedureComponent[]>;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  //Paginator Variables Decl
  procedures = [];
  pageNo: any = 1;
  pageNumber: boolean[] = [];
  searchTermMain: any = '';
  pageField = [];
  exactPageList: any;
  paginationData: number;
  proceduresPerPage: any = 10;
  totalProcedures: any;
  totalProceduresCount: any;
  searchResults: string = '';


  showedit = 0;
  constructor(public dialogRef: MatDialogRef<ProceduresDialogComponent>, private fb: FormBuilder
    , private router: Router
    , private route: ActivatedRoute
    , private proService: ProceduresService
    , private toastr: ToastrService
    , public dialog: MatDialog
    , public progressService: ProgressNotesService
    , private spinner: NgxSpinnerService
    , @Inject(MAT_DIALOG_DATA) public data: DialogData
  ) {
    if (!CommonComponents.pumpRefillVisibility) {
      //  if (sessionStorage.getItem("encounterid") != null || sessionStorage.getItem("encounterid") != undefined) {
      CommonComponents.encounterId = sessionStorage.getItem("encounterid");
      // }
      if (sessionStorage.getItem("patientId") != null || sessionStorage.getItem("patientId") != undefined) {
        CommonComponents.patientId = parseInt(sessionStorage.getItem("patientId"));
      }
      this.activetab = this.activetab - 1;
      this.loadProceduresCategorydata(); //
      this.loadProceduresLevelsdata(); //
      this.loadProceduresPartsdata();
      this.loadProceduresCptCodesdata(); //
      this.loadProceduresTypesdata(); //
      this.loadProceduresSidesdata(); //
      this.loadProceduresOthersdata(); //
      //this.loadAllFormProceduresdata();
      if (this.data != null) {
        this.showedit = this.data.notesType;
      }
    }
  }


  ngOnInit() {
    this.hidePagination = false;
    this.ProceduresForm = this.fb.group({
      LocationName: ['',],
      POS: ['',],
      procType: [''],
      procLevels: [''],
      // procName:[''],
      procPart: [''],
      procSide: [''],
      procOther: [''],
      searchTerm: [''],
      visitNoteProcedure: ['']
    });


    this.oncategoryIndex = 2;
    if (CommonComponents.encounterId && CommonComponents.patientId) {
      this.getProceduresInfo(CommonComponents.encounterId, CommonComponents.patientId);
      // this.getAllProblemsInfoById(CommonComponents.encounterId, CommonComponents.patientId);
      this.oncategoryIndex = 2;
      // alert("ngoninit");
      this.getAllCurrentProceduresInfoById(CommonComponents.encounterId, CommonComponents.patientId);
    }
    else {
      this.procedureInfo = {
        procCompId: null,
        patientId: null,
        encounterId: '',
        procType: '',
        procedureId: null,
        procedureName: '',
        procPart: '',
        sorceprocPart: [],
        sourcearrayProcLevels: [],
        procSide: '',
        procLevels: '',
        arrayProcLevels: [],
        procOther: '',
        arrayProcOther: [],
        procCPT: '',
        abn: '',
        qty: null,
        isActive: null,
        priority: null,
        createdBy: '',
        createdOn: null,
        modifiedBy: '',
        modifiedOn: null,
        isPast: null,
        procedureCPT: '',
        visitDate: null,
        aliasId: null,
        orASCProcId: null,
        procTempId: null,
        dateVisit: '',
        isOR: false
      };
      this.oncategoryIndex = 2;
      // this.loadAllFormProceduresdata();

      if (CommonComponents.patientId)
        this.getAllCurrentProceduresInfoById(null, CommonComponents.patientId);
    }

    this.visitDateFilter.valueChanges
      .subscribe(dateVisit => {
        this.filterValues.dateVisit = dateVisit;
        this.dataSource4.filter = JSON.stringify(this.filterValues);
      })

    this.typeFilter.valueChanges
      .subscribe(procType => {
        this.filterValues.type = procType;
        this.dataSource4.filter = JSON.stringify(this.filterValues);
      })

    this.sideFilter.valueChanges
      .subscribe(procSide => {
        this.filterValues.side = procSide;
        this.dataSource4.filter = JSON.stringify(this.filterValues);
      })

    this.procNameFilter.valueChanges
      .subscribe(procedureName => {
        this.filterValues.procedureName = procedureName;
        this.dataSource4.filter = JSON.stringify(this.filterValues);
      })

    this.levelsFilter.valueChanges
      .subscribe(procLevels => {
        this.filterValues.levels = procLevels;
        this.dataSource4.filter = JSON.stringify(this.filterValues);
      })

    this.cptCodesFilter.valueChanges
      .subscribe(procCPT => {
        this.filterValues.cptCode = procCPT;
        this.dataSource4.filter = JSON.stringify(this.filterValues);
      })

    this.qtyFilter.valueChanges
      .subscribe(qty => {
        this.filterValues.qty = qty;
        this.dataSource4.filter = JSON.stringify(this.filterValues);
      })

    this.othersFilter.valueChanges
      .subscribe(procOther => {
        this.filterValues.others = procOther;
        this.dataSource4.filter = JSON.stringify(this.filterValues);
      })

    this.ProceduresForm.get('searchTerm').valueChanges.subscribe(
      value => {
        if (value != undefined) {
          if (this.selectProcCategory == 2) {
            // if (CommonComponents.patientId)
            //   this.getAllCurrentProceduresInfoById(null, CommonComponents.patientId);
            this.dataSource3.data = this.onPatientProcSearchClick(value);
            if (this.dataSource3.data.length == 0) {
              this.searchResults = "No search results found."
              this.hidePagination = true;
            } else {
              this.searchResults = "";
              this.hidePagination = false;
            }
          }
          else if (this.isPreviousProcSearch) {
            this.dataSource4.data = this.onPreviousPatientProcSearchClick(value);
          } else if (this.selectProcCategory == 1) {
            this.loadAllFormProceduresdata();
            // alert("onsearch");
            // if (CommonComponents.patientId)
            //   this.getAllCurrentProceduresInfoById(null, CommonComponents.patientId);
            // this.searchTermMain = value;
            // this.showProceduresByPageNumber(1, 0);

            // this.dataSource2.data = this.onAllPatientProcedureSearcClick(value);
            // if (this.dataSource2.data.length == 0) {
            //   this.searchResults = "No search results found."
            //   this.hidePagination = true;
            // } else {
            //   this.searchResults = "";
            //   this.hidePagination = false;
            // }
          } else {
            // if (CommonComponents.patientId)
            //   this.getAllCurrentProceduresInfoById(null, CommonComponents.patientId);
            this.dataSource2.data = this.onAllCurrentPatientProcedureSearcClick(value);
            if (this.dataSource2.data.length == 0) {
              this.searchResults = "No search results found."
              this.hidePagination = true;
            } else {
              this.searchResults = "";
              this.hidePagination = false;
            }
          }
        }
      });

  }
  public hidepage: boolean;
  public categorychk: boolean;
  totalNoOfPages() {

    if (this.categorychk == true) {
      this.hidepage = true;
      this.pageField = [];
      this.paginationData = Number(this.totalProceduresCount / this.proceduresPerPage);
      let tempPageData = this.paginationData.toFixed();
      if (Number(tempPageData) < this.paginationData) {
        this.exactPageList = Number(tempPageData) + 1;
        this.proService.exactPageList = this.exactPageList;
      } else {
        this.exactPageList = Number(tempPageData);
        this.proService.exactPageList = this.exactPageList
      }
      this.proService.pageOnLoad();
      //this.insurance.pageField = this.pageField;
      this.pageField = this.proService.pageField;
    }
    else {
      this.hidepage = false;
    }
  }
  showProceduresByPageNumber(page, i) {
    this.procedures = [];
    this.pageNumber = [];
    this.pageNumber[i] = true;
    this.pageNo = page;
    this.proService.temppage = 0;
    if (this.selectProcCategory == 1) {
      this.IsAllProcedures = true;
      this.IsPatientProcedures = false;
      this.IsCheckedProcedures = false;
      this.spinner.show();
      this.proService.getAllProcedureData(this.selectProcCategory, this.pageNo, this.proceduresPerPage, this.searchTermMain).subscribe((data) => {

        this.ProceduresAllData = data;
        if (this.ProceduresAllData.length == 0) {
          this.searchResults = "No search results found."
          this.hidePagination = true;
        } else {
          this.searchResults = "";
          this.hidePagination = false;
        }
        this.dataSource2.data = this.ProceduresAllData;
        this.getCountAllProceduresDetails();
        this.spinner.hide();
      }
        , (err: any) => {
          console.log(err);
          this.spinner.hide();
        });
    }
    else if (this.selectProcCategory == 2) {
      this.IsAllProcedures = false;
      this.IsPatientProcedures = true;
      this.IsCheckedProcedures = false;
      this.dataSource3.data = this.patientprocedures;
      this.searchResults = "";
    }
    else {
      this.IsAllProcedures = true;
      this.IsPatientProcedures = false;
      this.IsCheckedProcedures = false;
      this.spinner.show();
      this.proService.getAllProcedureData(this.selectProcCategory, this.pageNo, this.proceduresPerPage, this.searchTermMain).subscribe((data) => {
        this.ProceduresAllData = data;
        if (this.ProceduresAllData.length == 0) {
          this.searchResults = "No search results found.";
          this.hidePagination = true;
        } else {
          this.searchResults = "";
          this.hidePagination = false;
        }
        this.dataSource2.data = this.ProceduresAllData;
        this.getCountAllProceduresDetails();
        this.spinner.hide();
      }
        , (err: any) => {
          console.log(err);
          this.spinner.hide();
        });
    }
  }

  getCountAllProceduresDetails() {
    if (this.selectProcCategory == 0) {
      this.selectProcCategory = 1;
    }
    this.proService.getCountProcedures(this.searchTermMain, this.selectProcCategory).subscribe(data => {
      this.totalProceduresCount = data;
      this.categorychk = true;
      this.totalNoOfPages();
    });
  }



  getProceduresInfo(encId: string, patId: number) {
    this.proService.getProceduresByEncId(encId, patId)
      .subscribe(
        (encProcInfo: IProcedureComponent[]) => {

          this.Currpatprocedures = [];
          if (encProcInfo.length > 0) {
            encProcInfo.forEach(element => {
              if (element.procedureName != null) {
                var levelArr;
                var othersArr;

                if (element.procLevels != null) {
                  levelArr = element.procLevels.split(',');
                }

                if (element.procOther != null) {
                  othersArr = element.procOther.split(',');
                }

                // if (this.procPartsdata.length > 0) {
                //   var CurParts;
                //   var curpartId;
                //   var Currele = this.procPartsdata.filter((attr: IProcedureParts) => attr.procedureId == element.procedureId);
                //   CurParts = Currele;
                //   if (Currele.length > 0) {
                //     var elecurpartId = Currele.filter((attr: IProcedureParts) => attr.partName == element.procPart);
                //     if (elecurpartId.length > 0) {
                //       curpartId = elecurpartId[0].partId;
                //     }
                //   }

                // }

                // if (this.procLevelsdata.length > 0 && curpartId > 0) {

                //   var CurLevels;
                //   var elemtlevel = this.procLevelsdata.filter((attr: IprocedureLevels) => attr.procedureId == element.procedureId && attr.partId == curpartId);
                //   CurLevels = elemtlevel;
                // }

                var curpartId = 0;
                if (element.procedureName.includes('Cervical') || element.procedureName.includes(('Cervical').toLowerCase())) {
                  curpartId = 1;
                }
                else if (element.procedureName.includes('Thoracic') || element.procedureName.includes(('Thoracic').toLowerCase())) {
                  curpartId = 2;
                }
                else if (element.procedureName.includes('Lumbar') || element.procedureName.includes(('Lumbar').toLowerCase())) {
                  curpartId = 3;
                }


                if (this.procLevelsdata.length > 0 && curpartId > 0) {
                  var CurLevels;
                  var elemtlevel = this.procLevelsdata.filter((attr: IprocedureLevels) => attr.partId == curpartId);
                  CurLevels = elemtlevel;
                }
                else {
                  var CurLevels;
                  var elemtlevel = this.procLevelsdata;
                  CurLevels = elemtlevel;
                }


                this.selctedProcedureCode = {

                  procCompId: element.procCompId,
                  patientId: element.patientId,
                  encounterId: element.encounterId,
                  procType: element.procType,
                  procedureId: element.procedureId,
                  procedureName: element.procedureName,
                  procPart: element.procPart,
                  procSide: element.procSide,
                  procLevels: element.procLevels,
                  arrayProcLevels: levelArr,
                  procOther: element.procOther,
                  arrayProcOther: othersArr,
                  procCPT: element.procCPT,
                  // sorceprocPart: CurParts,
                  priority: null,
                  sorceprocPart: [],
                  sourcearrayProcLevels: CurLevels,
                  abn: '',
                  qty: null,
                  isActive: true,
                  createdBy: encodeURIComponent(sessionStorage.getItem("userId")).toString(),
                  createdOn: null,
                  modifiedBy: '',
                  modifiedOn: null,
                  isPast: null,
                  procedureCPT: element.procedureCPT,
                  visitDate: null,
                  aliasId: null,
                  orASCProcId: element.orASCProcId,
                  procTempId: null,
                  dateVisit: '',
                  isOR: element.isOR
                }

                if (this.selctedProcedureCode != null) {

                  const removeCurrindex = this.Currpatprocedures.findIndex(
                    x => x.procType === (this.selctedProcedureCode.procType == "" ? "" : this.selctedProcedureCode.procType)
                      && x.procedureName === (this.selctedProcedureCode.procedureName == "" ? "" : this.selctedProcedureCode.procedureName)
                      // && x.procPart === (this.selctedProcedureCode.procPart == "" ? "" : this.selctedProcedureCode.procPart)
                      && x.procSide === (this.selctedProcedureCode.procSide == "" ? "" : this.selctedProcedureCode.procSide)
                  );
                  if (removeCurrindex != -1)
                    this.Currpatprocedures.splice(removeCurrindex, 1);

                  this.Currpatprocedures.push(this.selctedProcedureCode);
                  this.selctedProcedureCode = null;
                }
              }
            });
          }


          this.proceduresComponent = this.Currpatprocedures;
          this.dataSource.data = this.proceduresComponent;
          this.visitNoteProceduresdataSource.data = this.proceduresComponent;
        },
        (err: any) => console.log(err)
      );
  }

  getAllProblemsInfoById(encId: string, patId: number) {
    this.proService.getPatientProcByEncId(encId, patId)
      .subscribe(
        (encPatProcInfo: IProcedureComponent[]) => {

          if (encPatProcInfo.length > 0) {
            encPatProcInfo.forEach(element => {
              if (element.procedureName != null) {
                this.selctedProcedureCode = {

                  procCompId: 0,
                  patientId: CommonComponents.patientId,
                  encounterId: CommonComponents.encounterId,
                  procType: element.procType,
                  procedureId: element.procedureId,
                  procedureName: element.procedureName,
                  procPart: element.procPart,
                  procSide: element.procSide,
                  procLevels: element.procLevels,
                  arrayProcLevels: [],
                  procOther: element.procOther,
                  arrayProcOther: [],
                  sorceprocPart: [],
                  sourcearrayProcLevels: [],
                  procCPT: element.procCPT,
                  abn: '',
                  qty: null,
                  isActive: true,
                  createdBy: encodeURIComponent(sessionStorage.getItem("userId")).toString(),
                  createdOn: null,
                  modifiedBy: '',
                  modifiedOn: null,
                  isPast: true,
                  procedureCPT: element.procedureCPT,
                  visitDate: null,
                  priority: null,
                  aliasId: null,
                  orASCProcId: element.orASCProcId,
                  procTempId: null,
                  dateVisit: element.dateVisit,
                  isOR: element.isOR
                }

                if (this.selctedProcedureCode != null) {

                  const removepastindex = this.pastpatprocedures.findIndex(
                    x => x.procType === (this.selctedProcedureCode.procType == "" ? "" : this.selctedProcedureCode.procType)
                      && x.procedureName === (this.selctedProcedureCode.procedureName == "" ? "" : this.selctedProcedureCode.procedureName)
                      // && x.procPart === (this.selctedProcedureCode.procPart == "" ? "" : this.selctedProcedureCode.procPart)
                      && x.procSide === (this.selctedProcedureCode.procSide == "" ? "" : this.selctedProcedureCode.procSide)
                  );
                  if (removepastindex != -1)
                    this.pastpatprocedures.splice(removepastindex, 1);

                  this.pastpatprocedures.push(this.selctedProcedureCode);
                  this.selctedProcedureCode = null;
                }
              }
            });
          }
          this.patientprocedures = this.pastpatprocedures;
          this.IsAllProcedures = false;
          this.IsPatientProcedures = true;
          this.IsCheckedProcedures = false;
          this.dataSource3.data = this.patientprocedures;
          // this.visitNoteProceduresdataSource.data=this.patientprocedures;
          this.saveflag = true;
          this.hidePagination = true;
        },
        (err: any) => console.log(err)
      );
  }

  getAllCurrentProceduresInfoById(encId: string, patId: number) {
    // alert(encId);
    this.proService.getPatAllCurrentProceduresByEncId(encId)
      .subscribe(
        (encpatCurrAllProInfo: IProcedureComponent[]) => {
          if (encpatCurrAllProInfo.length > 0) {
            this.IsAllProcedures = false;
            this.IsPatientProcedures = true;
            this.IsCheckedProcedures = false;
            this.patientprocedures = encpatCurrAllProInfo;
            this.dataSource3.data = this.patientprocedures;
            this.dataSource3.paginator = this.paginator;
            this.saveflag = true;
            this.searchResults = "";
            // alert(this.selectProcCategory);
            this.hidePagination = true;
          }
          else {
            this.getAllProblemsInfoById(encId, patId);
          }
        },
        (err: any) => console.log(err)
      );
  }

  onNoClick(): void {
    this.dialogRef.close();
  }



  onAllPatientProcedureSearcClick(searchString: string) {

    return this.ProceduresAllData.filter((attr: IProceduresAllData) => (attr.procedureCPT.toLowerCase().indexOf(searchString.toLowerCase()) !== -1)
      || (attr.procedureName.toLowerCase().indexOf(searchString.toLowerCase()) !== -1));
  }
  onAllCurrentPatientProcedureSearcClick(searchString: string) {

    return this.ProceduresAllData.filter((attr: IProceduresAllData) => (attr.procedureCPT.toLowerCase().indexOf(searchString.toLowerCase()) !== -1)
      || (attr.procedureName.toLowerCase().indexOf(searchString.toLowerCase()) !== -1));
  }
  onProcedureSearcClick(searchString: string) {
    if (this.selectProcCategory > 2) {
      return this.ProceduresAllData.filter((attr: IProceduresAllData) => attr.categoryId == this.selectProcCategory && (attr.procedureName.toLowerCase().indexOf(searchString.toLowerCase()) !== -1));
    }
    else {
      return this.ProceduresAllData.filter((attr: IProceduresAllData) => attr.procedureName.toLowerCase().indexOf(searchString.toLowerCase()) !== -1);
    }
  }

  onPatientProcSearchClick(pbsearchString: string) {

    if (this.selectProcCategory == 2) {
      return this.patientprocedures.filter((attr: IProcedureComponent) => (attr.procCPT.toLowerCase().indexOf(pbsearchString.toLowerCase()) !== -1) || (attr.procedureName.toLowerCase().indexOf(pbsearchString.toLowerCase()) !== -1));
    }
  }

  onPreviousPatientProcSearchClick(previoussearchString: string) {
    if (this.isPreviousProcSearch) {
      return this.previousProcedures.filter((attr: IProcedureComponent) => attr.procedureName.toLowerCase().indexOf(previoussearchString.toLowerCase()) !== -1);
    }
  }
  ProcSearchClickVisitNoteProcedure(previoussearchString: string) {
    //   
    // if (this.isPreviousProcSearch) {
    return this.patientprocedures.filter((attr: IProcedureComponent) => attr.procedureName.toLowerCase().indexOf(previoussearchString.toLowerCase()) !== -1);
    // }
  }
  loadProceduresCategorydata() {
    this.proService.getProcedureCategory().subscribe((data) => {
      this.procCategorydata = data;
      this.dataSource1.data = this.procCategorydata;
      //this.loadProceduresByEncId();
    });
  }

  loadProceduresLevelsdata() {
    this.procLevelsdata = [];
    this.proService.getProcedureLevels({ partId: 0, levelName: '', isInsert: 0 }).subscribe((data) => {
      this.procLevelsdata = data;
      this.loadProceduresOthersdata();
    });
  }

  loadProceduresPartsdata() {
    this.proService.getProcedureParts().subscribe((data) => {
      this.procPartsdata = data;
    });
  }

  loadProceduresCptCodesdata() {
    this.proService.getProcedureCptCodes().subscribe((data) => {
      this.procCptsdata = data;
    });
  }

  loadProceduresTypesdata() {
    this.proService.getProcedureTypes().subscribe((data) => {
      this.procTypesdata = data;
      this.loadProceduresSidesdata();
    });
  }

  loadProceduresSidesdata() {
    this.proService.getProcedureSides().subscribe((data) => {
      this.procSidesdata = data;
      this.loadProceduresLevelsdata();
    });
  }

  loadProceduresOthersdata() {
    this.proService.getProcedureOthers().subscribe((data) => {
      this.procOthersdata = data;
      //this.loadAllFormProceduresdata();
    });
  }


  loadAllFormProceduresdata() {
    this.hidePagination = false;
    this.pageNumber[0] = true;
    this.pageNo = 1;
    this.selectProcCategory = 1;
    this.proService.temppage = 0;
    this.hidepage = true;
    this.proService.getAllProcedureData(1, this.pageNo, this.proceduresPerPage, '').subscribe((data) => {
      this.ProceduresAllData = data;
      this.dataSource2.data = this.ProceduresAllData;
      this.dataSource2.paginator = this.paginator;
      this.getCountAllProceduresDetails();
    });

  }

  // onProcedureCategoryClick(catgeoryId: number) {
  //   // alert("category clicked" + catgeoryId);
  //   this.selectProcCategory = catgeoryId;

  //   if (catgeoryId == 1) {
  //     this.IsAllProcedures = true;
  //     this.IsPatientProcedures = false;
  //     //this.VisitNoteProcedures = false
  //     this.dataSource2.data = this.ProceduresAllData;
  //     this.dataSource2.paginator = this.paginator;
  //   }
  //   else if (catgeoryId == 2) {
  //     this.IsAllProcedures = false;
  //     this.IsPatientProcedures = true;
  //     //this.VisitNoteProcedures = false
  //     this.dataSource3.data = this.patientprocedures;
  //   }
  //   else {
  //     this.IsAllProcedures = true;
  //     this.IsPatientProcedures = false;
  //     //this.VisitNoteProcedures = false

  //     this.dataSource2.data = this.ProceduresAllData.filter((attr: IProceduresAllData) => attr.categoryId == catgeoryId);
  //     this.dataSource2.paginator = this.paginator;

  //   }

  // }
  hidePagination: boolean = false;
  onProcedureCategoryClick(catgeoryId: number) {
    // alert("category clicked" + catgeoryId);
    this.searchResults = "";

    this.ProceduresForm.patchValue({
      procType: [''],
      procLevels: [''],
      // procName:[''],
      procPart: [''],
      procSide: [''],
      procOther: [''],
      searchTerm: [''],
      visitNoteProcedure: false,
    });
    this.selectProcCategory = catgeoryId;
    this.ischkUnchk = false;
    this.procedures = [];
    this.pageNumber = [];
    this.pageNumber[0] = true;
    this.pageNo = 1;
    this.proService.temppage = 0;
    this.searchTermMain = '';
    // alert(catgeoryId)
    if (catgeoryId == 1) {
      // this.IsAllProcedures = true;
      // this.IsPatientProcedures = false;
      // this.IsCheckedProcedures = false;
      // this.dataSource2.data = this.ProceduresAllData;
      // this.dataSource2.paginator = this.paginator;
      this.categorychk = true
      this.IsAllProcedures = true;
      this.IsPatientProcedures = false;
      this.IsCheckedProcedures = false;
      this.spinner.show();

      this.proService.getAllProcedureData(catgeoryId, this.pageNo, this.proceduresPerPage, '').subscribe((data) => {
        this.ProceduresAllData = data;
        if (this.ProceduresAllData.length == 0) {
          this.searchResults = "No search results found.";
          this.hidePagination = true;
        } else {
          this.searchResults = "";
          this.hidePagination = false;
        }
        this.dataSource2.data = this.ProceduresAllData;
        // this.dataSource2.paginator = this.paginator;
        //this.loadProceduresCategorydata();
        //this.loadProceduresTypesdata();
        //this.loadProceduresByEncId();        
        this.getCountAllProceduresDetails();
        this.spinner.hide();
      }
        , (err: any) => {
          console.log(err);
          this.spinner.hide();
        });
      //this.spinner.hide();
      // this.dataSource2.data = this.ProceduresAllData.filter((attr: IProceduresAllData) => attr.categoryId == catgeoryId);
      // this.dataSource2.paginator = this.paginator;

    }
    else if (catgeoryId == 2) {
      this.categorychk = false;
      this.IsAllProcedures = false;
      this.IsPatientProcedures = true;
      this.IsCheckedProcedures = false;
      this.dataSource3.data = this.patientprocedures;
    }
    else {
      this.categorychk = false;
      this.IsPatientProcedures = false;
      this.IsCheckedProcedures = false;
      this.IsAllProcedures = true;
      this.spinner.show();

      this.proService.getAllProcedureData(catgeoryId, this.pageNo, this.proceduresPerPage, '').subscribe((data) => {
        this.ProceduresAllData = data;
        if (this.ProceduresAllData.length == 0) {
          //this.searchResults = "No search results found."
          this.searchResults = "";
          this.hidePagination = true;
        } else {
          this.searchResults = "";
          this.hidePagination = false;
        }
        this.dataSource2.data = this.ProceduresAllData;
        // this.dataSource2.paginator = this.paginator;
        //this.loadProceduresCategorydata();
        //this.loadProceduresTypesdata();
        //this.loadProceduresByEncId();      
        this.getCountAllProceduresDetails();
        this.spinner.hide();
        // this.getCountAllProceduresDetails();
      }
        , (err: any) => {
          console.log(err);
          this.spinner.hide();
        });
      //this.spinner.hide();
      // this.dataSource2.data = this.ProceduresAllData.filter((attr: IProceduresAllData) => attr.categoryId == catgeoryId);
      // this.dataSource2.paginator = this.paginator;

    }
  }
  onkeySearch() {

    //if(this.ProceduresForm.value.searchTerm === ''){
    this.onSearchClick();
    // }

  }
  onSearchClick() {
    if (this.selectProcCategory !== 2 && this.selectProcCategory !== -1) {
      if (this.ProceduresForm.value.searchTerm !== null && this.ProceduresForm.value.searchTerm !== undefined && this.ProceduresForm.value.searchTerm !== '') {
        this.searchTermMain = this.ProceduresForm.value.searchTerm;
        this.showProceduresByPageNumber(1, 0);
      } else {
        this.searchTermMain = '';
        this.showProceduresByPageNumber(1, 0);
      }
    }
  }

  onKeyPressOther() {

    // if(this.selectProcCategory == 2 || this.selectProcCategory == -1){
    this.ProceduresForm.get('searchTerm').valueChanges.subscribe(
      value => {
        if (value != undefined) {
          if (this.selectProcCategory == 2) {

            this.dataSource3.data = this.onPatientProcSearchClick(value);
            if (this.dataSource3.data.length == 0) {
              this.searchResults = "No search results found."
              this.hidePagination = true;
            } else {
              this.searchResults = "";
              this.hidePagination = false;
            }
          }
          else if (this.isPreviousProcSearch) {
            this.dataSource4.data = this.onPreviousPatientProcSearchClick(value);
          } else if (this.selectProcCategory == 1) {
            this.searchTermMain = value;
            this.showProceduresByPageNumber(1, 0);
            // this.dataSource2.data = this.onAllPatientProcedureSearcClick(value);
            // if (this.dataSource2.data.length == 0) {
            //   this.searchResults = "No search results found."
            //   this.hidePagination = true;
            // } else {
            //   this.searchResults = "";
            //   this.hidePagination = false;
            // }

          } else {
            this.dataSource2.data = this.onAllCurrentPatientProcedureSearcClick(value);
            if (this.dataSource2.data.length == 0) {
              this.searchResults = "No search results found."
              this.hidePagination = true;
            } else {
              this.searchResults = "";
              this.hidePagination = false;
            }
          }
          // else{
          //   this.dataSource4.data = this.onPatientProcSearchClick(value);
          //   if (this.dataSource3.data.length == 0) {
          //     this.searchResults = "No search results found."
          //     this.hidePagination = true;
          //   } else {
          //     this.searchResults = "";
          //     this.hidePagination = false;
          //   }
          // }
        }
      });
    // }else if(this.selectProcCategory == 1){

    // }else{

    // }
  }

  levelslst: IprocedureLevels[] = [];
  ProcPartChange(value, procId: number) {
    var elemt1 = this.ProceduresAllData.filter((attr: IProceduresAllData) => attr.procedureId == procId);
    var elemt = this.procLevelsdata.filter((attr: IprocedureLevels) => attr.procedureId == procId && attr.partId == value);
    elemt1[0].procedureLevels = elemt;
  }


  CurrEncProcPartChange(value, element: IProcedureComponent) {
    var curEncpartId;
    var CurEncElemt;
    var cptCode;
    var _pastEvelname;
    var prevPart;
    var preLevels;
    var Currele = this.procPartsdata.filter((attr: IProcedureParts) => attr.procedureId == element.procedureId);

    if (Currele.length > 0) {
      var elecurpartId = Currele.filter((attr: IProcedureParts) => attr.partName == value);
      if (elecurpartId.length > 0)
        curEncpartId = elecurpartId[0].partId;
    }

    if (curEncpartId > 0) {
      var curCptCode = this.procCptsdata.filter((attr: IprocedureCPTCodes) => attr.procedureId == element.procedureId && attr.partId == curEncpartId);
      if (curCptCode.length > 0)
        cptCode = curCptCode[0].cptCodes;
    }

    // var curEncelemt1 = this.proceduresComponent.filter((attr: IProcedureComponent) => attr.procedureId == procId);
    var curEncelemt1 = this.proceduresComponent.filter(x => x.procType === (element.procType == "" ? "" : element.procType)
      && x.procedureName === (element.procedureName == "" ? "" : element.procedureName)
      && x.procPart === (element.procPart == "" ? "" : element.procPart)
      && x.procSide === (element.procSide == "" ? "" : element.procSide));

    var pastEncelemt1 = this.patientprocedures.filter(x => x.procType === (element.procType == "" ? "" : element.procType)
      && x.procedureName === (element.procedureName == "" ? "" : element.procedureName)
      && x.procPart === (element.procPart == "" ? "" : element.procPart)
      && x.procSide === (element.procSide == "" ? "" : element.procSide));

    prevPart = curEncelemt1[0].procPart;
    preLevels = curEncelemt1[0].procLevels;
    if (curEncpartId > 0) {
      CurEncElemt = this.procLevelsdata.filter((attr: IprocedureLevels) => attr.procedureId == element.procedureId && attr.partId == curEncpartId);
      if (CurEncElemt.length > 0) {
        curEncelemt1[0].sourcearrayProcLevels = CurEncElemt;
        if (prevPart == value) {
          pastEncelemt1[0].procLevels = preLevels;
        }
        else {
          pastEncelemt1[0].procLevels = '';
        }
      }
      else {
        curEncelemt1[0].sourcearrayProcLevels = [];
        if (pastEncelemt1.length > 0)
          pastEncelemt1[0].procLevels = '';

      }

      curEncelemt1[0].procPart = value;
      curEncelemt1[0].procCPT = cptCode;
    }

    if (pastEncelemt1.length > 0) {
      pastEncelemt1[0].procPart = value;
      pastEncelemt1[0].procCPT = cptCode;
    }


  }

  CurrEncProcLevelChange(value, element: IProcedureComponent) {

    // var curEnclemt1 = this.proceduresComponent.filter((attr: IProcedureComponent) => attr.procedureId == procId);
    var curEnclemt1 = this.proceduresComponent.filter(x => x.procType === (element.procType == "" ? "" : element.procType)
      && x.procedureName === (element.procedureName == "" ? "" : element.procedureName)
      // && x.procPart === (element.procPart == "" ? "" : element.procPart)
      && x.procSide === (element.procSide == "" ? "" : element.procSide));

    var pastEncelemt1 = this.patientprocedures.filter(x => x.procType === (element.procType == "" ? "" : element.procType)
      && x.procedureName === (element.procedureName == "" ? "" : element.procedureName)
      // && x.procPart === (element.procPart == "" ? "" : element.procPart)
      && x.procSide === (element.procSide == "" ? "" : element.procSide));

    var _curlEvelname;
    var _curArrayLevelName;

    if (value.length > 0) {
      _curlEvelname = '';
      _curArrayLevelName = [];
      value.forEach(elementlevel => {
        _curArrayLevelName.push(elementlevel);
        _curlEvelname += elementlevel + ',';
      });
      if (_curlEvelname.endsWith(',')) {
        _curlEvelname = _curlEvelname.slice(0, (_curlEvelname.length - 1));
      }

    }
    if (curEnclemt1.length > 0) {
      curEnclemt1[0].procLevels = _curlEvelname;
      curEnclemt1[0].arrayProcLevels = _curArrayLevelName;
    }

    if (pastEncelemt1.length > 0) {
      pastEncelemt1[0].procLevels = _curlEvelname;
    }
  }

  CurrEncProcSideChange(value, element: IProcedureComponent) {

    // var curEncSemt1 = this.proceduresComponent.filter((attr: IProcedureComponent) => attr.procedureId == procId);
    var curEncSemt1 = this.proceduresComponent.filter(x => x.procType === (element.procType == "" ? "" : element.procType)
      && x.procedureName === (element.procedureName == "" ? "" : element.procedureName)
      // && x.procPart === (element.procPart == "" ? "" : element.procPart)
      && x.procSide === (element.procSide == "" ? "" : element.procSide));

    var pastEncelemt1 = this.patientprocedures.filter(x => x.procType === (element.procType == "" ? "" : element.procType)
      && x.procedureName === (element.procedureName == "" ? "" : element.procedureName)
      // && x.procPart === (element.procPart == "" ? "" : element.procPart)
      && x.procSide === (element.procSide == "" ? "" : element.procSide));

    if (curEncSemt1.length > 0) {
      curEncSemt1[0].procSide = value;
    }

    if (pastEncelemt1.length > 0) {
      pastEncelemt1[0].procSide = value;
    }

  }

  CurrEncProcTypeChange(value, element: IProcedureComponent) {

    // var curEncTemt1 = this.proceduresComponent.filter((attr: IProcedureComponent) => attr.procedureId == procId);

    var curEncTemt1 = this.proceduresComponent.filter(x => x.procType === (element.procType == "" ? "" : element.procType)
      && x.procedureName === (element.procedureName == "" ? "" : element.procedureName)
      // && x.procPart === (element.procPart == "" ? "" : element.procPart)
      && x.procSide === (element.procSide == "" ? "" : element.procSide));

    var pastEncelemt1 = this.patientprocedures.filter(x => x.procType === (element.procType == "" ? "" : element.procType)
      && x.procedureName === (element.procedureName == "" ? "" : element.procedureName)
      // && x.procPart === (element.procPart == "" ? "" : element.procPart)
      && x.procSide === (element.procSide == "" ? "" : element.procSide));

    if (curEncTemt1.length > 0) {
      curEncTemt1[0].procType = value;
    }
    if (pastEncelemt1.length > 0) {
      pastEncelemt1[0].procType = value;
    }

  }

  CurrEncProcSOtherChange(value, element: IProcedureComponent) {

    // var curEncOemt1 = this.proceduresComponent.filter((attr: IProcedureComponent) => attr.procedureId == procId);
    var curEncOemt1 = this.proceduresComponent.filter(x => x.procType === (element.procType == "" ? "" : element.procType)
      && x.procedureName === (element.procedureName == "" ? "" : element.procedureName)
      // && x.procPart === (element.procPart == "" ? "" : element.procPart)
      && x.procSide === (element.procSide == "" ? "" : element.procSide));

    var pastEncelemt1 = this.patientprocedures.filter(x => x.procType === (element.procType == "" ? "" : element.procType)
      && x.procedureName === (element.procedureName == "" ? "" : element.procedureName)
      // && x.procPart === (element.procPart == "" ? "" : element.procPart)
      && x.procSide === (element.procSide == "" ? "" : element.procSide));

    var _curOthername;
    var _curArrayOthername;

    if (value.length > 0) {
      _curOthername = '';
      _curArrayOthername = [];
      value.forEach(elementlevel => {
        _curArrayOthername.push(elementlevel);
        _curOthername += elementlevel + ',';
      });
      if (_curOthername.endsWith(',')) {
        _curOthername = _curOthername.slice(0, (_curOthername.length - 1));
      }

    }
    if (curEncOemt1.length > 0) {
      curEncOemt1[0].procOther = _curOthername;
      curEncOemt1[0].arrayProcOther = _curArrayOthername;
    }

    if (pastEncelemt1.length > 0) {
      pastEncelemt1[0].procOther = _curOthername;
    }

  }


  onProcedureEditClick(element: IProcedureComponent) {

    this.procPartsdata = this.procPartsdata.filter((attr: IProcedureParts) => attr.procedureId == element.procedureId);

  }
  //addProcedurelist: IProceduresAllData[] = [];
  singleProcObjList: IProcedureComponent[] = [];
  ProcAddToEncounter(element: IProceduresAllData) {
    if (element.procedureCPT == "00000") {
      const message = "The selected CPT represents a Non-Charge Visit. A claim will not be automatically generated for this encounter. The user must confirm before proceeding.";
      const dialogData = new ConfirmDialogModel('Confirm Action', message);
      const dialogRef = this.dialog.open(DeleteDocumentComponent, {
        maxWidth: '500px',
        height: '160px',
        data: dialogData
      });

      dialogRef.afterClosed().subscribe(dialogResult => {
        this.result = dialogResult;
        if (this.result) {
          if (element != null) {
            if (element.procedureTypes != null) {
              var eleType = element.procedureTypes.filter((attrt: IprocedureTypes) => attrt.typeId == this.ProceduresForm.value.procType);
              if (eleType.length > 0)
                var _typename = eleType[0].typeName;
            }
            var _procName = element.procedureName;
            var _procId = element.procedureId;
            var _cptcode = element.procedureCPT;
            if (element.procedureSides != null) {
              var eleSide = element.procedureSides.filter((attrt: IprocedureSides) => attrt.sideId == this.ProceduresForm.value.procSide);
              if (eleSide.length > 0)
                var _sidename = eleSide[0].sideName;
            }

            if (element.procedureLevels != null) {
              var eleprocLevels;
              eleprocLevels = element.procedureLevels;
              var eleLevel = [];
              var _levelname;
              var _arrayLevelName;
              if (this.ProceduresForm.value.procLevels.length > 0) {
                eleLevel = [];
                _levelname = '';
                _arrayLevelName = [];
                this.ProceduresForm.value.procLevels.forEach(elementlevel => {
                  eleLevel = element.procedureLevels.filter((attrt: IprocedureLevels) => attrt.levelId == elementlevel);
                  if (eleLevel.length > 0) {
                    if (eleLevel[0].levelName != null) {
                      _arrayLevelName.push(eleLevel[0].levelName);
                      if (_levelname == undefined) {
                        _levelname = '';
                      }
                      else {
                        _levelname += eleLevel[0].levelName + ',';
                      }
                    }
                  }

                });
                if (_levelname != undefined && _levelname.endsWith(',')) {
                  _levelname = _levelname.slice(0, (_levelname.length - 1));
                }

              }
            }
            if (element.procedureOthers != null) {
              var eleOther = [];
              var _othername;
              var _arrayOthername;
              if (this.ProceduresForm.value.procOther.length > 0) {
                eleOther = [];
                _othername = '';
                _arrayOthername = [];
                this.ProceduresForm.value.procOther.forEach(elementOther => {
                  eleOther = element.procedureOthers.filter((attrt: IprocedureOthers) => attrt.otherId == elementOther);
                  if (eleOther.length > 0) {
                    if (eleOther[0].otherName != null) {
                      _arrayOthername.push(eleOther[0].otherName);
                      if (_othername == undefined) {
                        _othername = '';
                      } else {
                        _othername += eleOther[0].otherName + ',';
                      }
                    }
                  }
                });
                if (_othername != undefined && _othername.endsWith(',')) {
                  _othername = _othername.slice(0, (_othername.length - 1));
                }
              }
            }
          }

          this.selectedProcComponentData = {
            procCompId: 0,
            patientId: CommonComponents.patientId,
            encounterId: CommonComponents.encounterId,
            procType: _typename,
            procedureId: _procId,
            procedureName: _procName,
            procPart: null,
            procSide: _sidename,
            procLevels: _levelname,
            arrayProcLevels: _arrayLevelName,
            procOther: _othername,
            arrayProcOther: _arrayOthername,
            procCPT: _cptcode,
            sorceprocPart: [],
            sourcearrayProcLevels: eleprocLevels,
            abn: '',
            qty: 1,
            isActive: true,
            createdBy: encodeURIComponent(sessionStorage.getItem("userId")).toString(),
            createdOn: null,
            modifiedBy: '',
            modifiedOn: null,
            isPast: null,
            procedureCPT: element.procedureCPT,
            visitDate: null,
            aliasId: null,
            priority: null,
            orASCProcId: null,
            procTempId: null,
            dateVisit: '',
            isOR: false,
            categoryId: element.categoryId
          }

          if (this.selectedProcComponentData != null) {
            const removeindex1 = this.proceduresComponent.findIndex(
              x => x.procType === (this.selectedProcComponentData.procType == "" ? "" : this.selectedProcComponentData.procType)
                && x.procedureName === (this.selectedProcComponentData.procedureName == "" ? "" : this.selectedProcComponentData.procedureName)
                //&& x.procPart === (this.selectedProcComponentData.procPart == "" ? "" : this.selectedProcComponentData.procPart)
                && x.procSide === (this.selectedProcComponentData.procSide == "" ? "" : this.selectedProcComponentData.procSide)
              // && x.procOther === (this.selectedProcComponentData.procOther == "" ? "" : this.selectedProcComponentData.procOther)
            );

            if (removeindex1 == -1)
              // this.proceduresComponent.splice(0, 0, this.selectedProcComponentData);
              this.proceduresComponent.push(this.selectedProcComponentData);

            const removeindex = this.patientprocedures.findIndex(
              x => x.procType === (this.selectedProcComponentData.procType == "" ? "" : this.selectedProcComponentData.procType)
                && x.procedureName === (this.selectedProcComponentData.procedureName == "" ? "" : this.selectedProcComponentData.procedureName)
                //&& x.procPart === (this.selectedProcComponentData.procPart == "" ? "" : this.selectedProcComponentData.procPart)
                && x.procSide === (this.selectedProcComponentData.procSide == "" ? "" : this.selectedProcComponentData.procSide)
              // && x.procOther === (this.selectedProcComponentData.procOther == "" ? "" : this.selectedProcComponentData.procOther)
            );
            if (removeindex == -1)
              // this.patientprocedures.splice(0, 0, this.selectedProcComponentData);
              this.patientprocedures.push(this.selectedProcComponentData);
          }
          if (this.showedit == 0) {
            const dialogReff = this.dialog.open(PatientProceduresComponent, {
              width: '600px',
              height: '300px',
              data: {
                procedureName: this.selectedProcComponentData.procedureName, procSide: this.selectedProcComponentData.procSide
                , procType: this.selectedProcComponentData.procType, procLevels: this.selectedProcComponentData.procLevels
                , procCode: this.selectedProcComponentData.procedureCPT
              }
            });

            dialogReff.afterClosed().subscribe(result => {
              this.selectedProcComponentData.procLevels = result.procLevels;
              this.selectedProcComponentData.procSide = result.procSide;
              this.selectedProcComponentData.procType = result.procType;
              this.dialogRef.close(this.selectedProcComponentData);
              this.selectedProcComponentData = null
              this.dataSource.data = this.proceduresComponent;
              this.dataSource3.data = this.patientprocedures;

            });
          }
          else {
            this.dialogRef.close(this.selectedProcComponentData);
            this.selectedProcComponentData = null
            this.dataSource.data = this.proceduresComponent;
            this.dataSource3.data = this.patientprocedures;
          }
          this.ProceduresForm.patchValue({
            procType: [''],
            procLevels: [''],
            // procName:[''],
            // procPart: [''],
            procSide: [''],
            procOther: [''],
          });
        }
      });
    } else {
      if (element != null) {
        if (element.procedureTypes != null) {
          var eleType = element.procedureTypes.filter((attrt: IprocedureTypes) => attrt.typeId == this.ProceduresForm.value.procType);
          if (eleType.length > 0)
            var _typename = eleType[0].typeName;
        }
        var _procName = element.procedureName;
        var _procId = element.procedureId;
        var _cptcode = element.procedureCPT;
        if (element.procedureSides != null) {
          var eleSide = element.procedureSides.filter((attrt: IprocedureSides) => attrt.sideId == this.ProceduresForm.value.procSide);
          if (eleSide.length > 0)
            var _sidename = eleSide[0].sideName;
        }

        if (element.procedureLevels != null) {
          var eleprocLevels;
          eleprocLevels = element.procedureLevels;
          var eleLevel = [];
          var _levelname;
          var _arrayLevelName;
          if (this.ProceduresForm.value.procLevels.length > 0) {
            eleLevel = [];
            _levelname = '';
            _arrayLevelName = [];
            this.ProceduresForm.value.procLevels.forEach(elementlevel => {
              eleLevel = element.procedureLevels.filter((attrt: IprocedureLevels) => attrt.levelId == elementlevel);
              if (eleLevel.length > 0) {
                if (eleLevel[0].levelName != null) {
                  _arrayLevelName.push(eleLevel[0].levelName);
                  if (_levelname == undefined) {
                    _levelname = '';
                  }
                  else {
                    _levelname += eleLevel[0].levelName + ',';
                  }
                }
              }

            });
            if (_levelname != undefined && _levelname.endsWith(',')) {
              _levelname = _levelname.slice(0, (_levelname.length - 1));
            }

          }
        }
        if (element.procedureOthers != null) {
          var eleOther = [];
          var _othername;
          var _arrayOthername;
          if (this.ProceduresForm.value.procOther.length > 0) {
            eleOther = [];
            _othername = '';
            _arrayOthername = [];
            this.ProceduresForm.value.procOther.forEach(elementOther => {
              eleOther = element.procedureOthers.filter((attrt: IprocedureOthers) => attrt.otherId == elementOther);
              if (eleOther.length > 0) {
                if (eleOther[0].otherName != null) {
                  _arrayOthername.push(eleOther[0].otherName);
                  if (_othername == undefined) {
                    _othername = '';
                  } else {
                    _othername += eleOther[0].otherName + ',';
                  }
                }
              }
            });
            if (_othername != undefined && _othername.endsWith(',')) {
              _othername = _othername.slice(0, (_othername.length - 1));
            }
          }
        }
      }

      this.selectedProcComponentData = {
        procCompId: 0,
        patientId: CommonComponents.patientId,
        encounterId: CommonComponents.encounterId,
        procType: _typename,
        procedureId: _procId,
        procedureName: _procName,
        procPart: null,
        procSide: _sidename,
        procLevels: _levelname,
        arrayProcLevels: _arrayLevelName,
        procOther: _othername,
        arrayProcOther: _arrayOthername,
        procCPT: _cptcode,
        sorceprocPart: [],
        sourcearrayProcLevels: eleprocLevels,
        abn: '',
        qty: 1,
        isActive: true,
        createdBy: encodeURIComponent(sessionStorage.getItem("userId")).toString(),
        createdOn: null,
        modifiedBy: '',
        modifiedOn: null,
        isPast: null,
        procedureCPT: element.procedureCPT,
        visitDate: null,
        aliasId: null,
        priority: null,
        orASCProcId: null,
        procTempId: null,
        dateVisit: '',
        isOR: false,
        categoryId: element.categoryId
      }

      if (this.selectedProcComponentData != null) {
        const removeindex1 = this.proceduresComponent.findIndex(
          x => x.procType === (this.selectedProcComponentData.procType == "" ? "" : this.selectedProcComponentData.procType)
            && x.procedureName === (this.selectedProcComponentData.procedureName == "" ? "" : this.selectedProcComponentData.procedureName)
            //&& x.procPart === (this.selectedProcComponentData.procPart == "" ? "" : this.selectedProcComponentData.procPart)
            && x.procSide === (this.selectedProcComponentData.procSide == "" ? "" : this.selectedProcComponentData.procSide)
          // && x.procOther === (this.selectedProcComponentData.procOther == "" ? "" : this.selectedProcComponentData.procOther)
        );

        if (removeindex1 == -1)
          // this.proceduresComponent.splice(0, 0, this.selectedProcComponentData);
          this.proceduresComponent.push(this.selectedProcComponentData);

        const removeindex = this.patientprocedures.findIndex(
          x => x.procType === (this.selectedProcComponentData.procType == "" ? "" : this.selectedProcComponentData.procType)
            && x.procedureName === (this.selectedProcComponentData.procedureName == "" ? "" : this.selectedProcComponentData.procedureName)
            //&& x.procPart === (this.selectedProcComponentData.procPart == "" ? "" : this.selectedProcComponentData.procPart)
            && x.procSide === (this.selectedProcComponentData.procSide == "" ? "" : this.selectedProcComponentData.procSide)
          // && x.procOther === (this.selectedProcComponentData.procOther == "" ? "" : this.selectedProcComponentData.procOther)
        );
        if (removeindex == -1)
          // this.patientprocedures.splice(0, 0, this.selectedProcComponentData);
          this.patientprocedures.push(this.selectedProcComponentData);
      }
      if (this.showedit == 0) {
        const dialogReff = this.dialog.open(PatientProceduresComponent, {
          width: '600px',
          height: '300px',
          data: {
            procedureName: this.selectedProcComponentData.procedureName, procSide: this.selectedProcComponentData.procSide
            , procType: this.selectedProcComponentData.procType, procLevels: this.selectedProcComponentData.procLevels
            , procCode: this.selectedProcComponentData.procedureCPT
          }
        });

        dialogReff.afterClosed().subscribe(result => {
          this.selectedProcComponentData.procLevels = result.procLevels;
          this.selectedProcComponentData.procSide = result.procSide;
          this.selectedProcComponentData.procType = result.procType;
          this.dialogRef.close(this.selectedProcComponentData);
          this.selectedProcComponentData = null
          this.dataSource.data = this.proceduresComponent;
          this.dataSource3.data = this.patientprocedures;

        });
      }
      else {
        this.dialogRef.close(this.selectedProcComponentData);
        this.selectedProcComponentData = null
        this.dataSource.data = this.proceduresComponent;
        this.dataSource3.data = this.patientprocedures;
      }
      this.ProceduresForm.patchValue({
        procType: [''],
        procLevels: [''],
        // procName:[''],
        // procPart: [''],
        procSide: [''],
        procOther: [''],
      });
    }
  }

  ProclevelData(element: IProceduresAllData) {
    var curpartId = 0;
    if (element.procedureName.includes(('Cervical').toLowerCase()) || element.procedureName.includes('Cervical')) {
      curpartId = 1;
    }
    else if (element.procedureName.includes(('Thoracic').toLowerCase()) || element.procedureName.includes('Thoracic')) {
      curpartId = 2;
    }
    else if (element.procedureName.includes(('Lumbar').toLowerCase()) || element.procedureName.includes('Lumbar')) {
      curpartId = 3;
    }

    if (curpartId > 0) {
      var elemt1 = this.ProceduresAllData.filter((attr: IProceduresAllData) => attr.procedureId == element.procedureId);
      var elemt = this.procLevelsdata.filter((attr: IprocedureLevels) => attr.partId == curpartId);
      elemt1[0].procedureLevels = elemt;
    }
    else {
      var elemt1 = this.ProceduresAllData.filter((attr: IProceduresAllData) => attr.procedureId == element.procedureId);
      var elemt = this.procLevelsdata;
      elemt1[0].procedureLevels = elemt;
    }
  }

  // onSubmit() {
  //   this.submitted = true;
  // }
  //   onPastProcedureAddClick(element: IProceduresAllData) {
  //      // alert("category clicked" + this.ProceduresForm.value.procPart);
  //      if (element != null) {
  //       if (element.procedureTypes != null) {
  //         var eleType = element.procedureTypes.filter((attrt: IprocedureTypes) => attrt.typeId == this.ProceduresForm.value.procType);
  //         if (eleType.length > 0)
  //           var _typename = eleType[0].typeName;
  //       }
  //       if (element.procedureParts != null) {
  //         var eleprocParts;
  //         eleprocParts = element.procedureParts;
  //         var elePart = element.procedureParts.filter((attrd: IProcedureParts) => attrd.partId == this.ProceduresForm.value.procPart);
  //         if (elePart.length > 0)
  //           var _partname = elePart[0].partName;
  //       }
  //       var _procName = element.procedureName;
  //       var _procId = element.procedureId;
  //       if (element.procedureSides != null) {
  //         var eleSide = element.procedureSides.filter((attrt: IprocedureSides) => attrt.sideId == this.ProceduresForm.value.procSide);
  //         if (eleSide.length > 0)
  //           var _sidename = eleSide[0].sideName;
  //       }

  //       // if (element.procedureLevels != null) {
  //       //   var eleLevel = [];
  //       //   var _levelname;
  //       //   if (this.ProceduresForm.value.procLevels.length > 0) {
  //       //     eleLevel = [];
  //       //     _levelname = '';
  //       //     this.ProceduresForm.value.procLevels.forEach(elementlevel => {
  //       //       eleLevel = element.procedureLevels.filter((attrt: IprocedureLevels) => attrt.levelId == elementlevel);
  //       //       if (eleLevel.length > 0)
  //       //         _levelname += eleLevel[0].levelName + ',';
  //       //     });
  //       //     if (_levelname.endsWith(',')) {
  //       //       _levelname = _levelname.slice(0, (_levelname.length - 1));
  //       //     }

  //       //   }
  //       // }
  //       if (element.procedureLevels != null) {
  //         var eleprocLevels;
  //         eleprocLevels = element.procedureLevels;
  //         var eleLevel = [];
  //         var _levelname;
  //         var _arrayLevelName;
  //         if (this.ProceduresForm.value.procLevels.length > 0) {
  //           eleLevel = [];
  //           _levelname = '';
  //           _arrayLevelName = [];
  //           this.ProceduresForm.value.procLevels.forEach(elementlevel => {
  //             eleLevel = element.procedureLevels.filter((attrt: IprocedureLevels) => attrt.levelId == elementlevel);
  //             if (eleLevel.length > 0) {
  //               _arrayLevelName.push(eleLevel[0].levelName);
  //               _levelname += eleLevel[0].levelName + ',';
  //             }

  //           });
  //           if (_levelname.endsWith(',')) {
  //             _levelname = _levelname.slice(0, (_levelname.length - 1));
  //           }

  //         }
  //       }
  //       // if (element.procedureOthers != null) {
  //       //   var eleOther = [];
  //       //   var _othername;
  //       //   if (this.ProceduresForm.value.procOther.length > 0) {
  //       //     eleOther = [];
  //       //     _othername = '';
  //       //     this.ProceduresForm.value.procOther.forEach(elementOther => {
  //       //       eleOther = element.procedureOthers.filter((attrt: IprocedureOthers) => attrt.otherId == elementOther);
  //       //       if (eleOther.length > 0)
  //       //         _othername += eleOther[0].otherName + ',';
  //       //     });
  //       //     if (_othername.endsWith(',')) {
  //       //       _othername = _othername.slice(0, (_othername.length - 1));
  //       //     }

  //       //   }
  //       // }
  //       if (element.procedureOthers != null) {
  //         var eleOther = [];
  //         var _othername;
  //         var _arrayOthername;
  //         if (this.ProceduresForm.value.procOther.length > 0) {
  //           eleOther = [];
  //           _othername = '';
  //           _arrayOthername = [];
  //           this.ProceduresForm.value.procOther.forEach(elementOther => {
  //             eleOther = element.procedureOthers.filter((attrt: IprocedureOthers) => attrt.otherId == elementOther);
  //             if (eleOther.length > 0) {
  //               _arrayOthername.push(eleOther[0].otherName);
  //               _othername += eleOther[0].otherName + ',';
  //             }

  //           });
  //           if (_othername.endsWith(',')) {
  //             _othername = _othername.slice(0, (_othername.length - 1));
  //           }

  //         }
  //       }
  //       // if (element.procedureOthers != null) {
  //       //   var eleOther = element.procedureOthers.filter((attrt: IprocedureOthers) => attrt.otherId == this.ProceduresForm.value.procOther);
  //       //   if (eleOther.length > 0)
  //       //     var _othername = eleOther[0].otherName;
  //       // }
  //       if (element.procedureCPTCodes != null) {
  //         var eleCpt = element.procedureCPTCodes.filter((attrd: IprocedureCPTCodes) => attrd.partId == this.ProceduresForm.value.procPart && attrd.procedureId == element.procedureId);
  //         if (eleCpt.length > 0)
  //           var _cptcode = eleCpt[0].cptCodes;
  //       }
  //     }

  //     this.selectedProcComponentData = {

  //       procCompId: 0,
  //       patientId: CommonComponents.patientId,
  //       encounterId: CommonComponents.encounterId,
  //       procType: _typename,
  //       procedureId: _procId,
  //       procedureName: _procName,
  //       procPart: _partname,
  //       procSide: _sidename,
  //       procLevels: _levelname,
  //       arrayProcLevels: _arrayLevelName,
  //       procOther: _othername,
  //       arrayProcOther: _arrayOthername,
  //       procCPT: _cptcode,
  //       sorceprocPart: eleprocParts,
  //       sourcearrayProcLevels: eleprocLevels,
  //       abn: '',
  //       qty: null,
  //       isActive: true,
  //       createdBy: 'admin',
  //       createdOn: null,
  //       modifiedBy: '',
  //       modifiedOn: null,
  //       isPast: null,
  //     }

  //     if (this.selectedProcComponentData != null) {

  //       const removeindex1 = this.proceduresComponent.findIndex(
  //         x => x.procType === (this.selectedProcComponentData.procType == "" ? "" : this.selectedProcComponentData.procType)
  //           && x.procedureName === (this.selectedProcComponentData.procedureName == "" ? "" : this.selectedProcComponentData.procedureName)
  //           && x.procPart === (this.selectedProcComponentData.procPart == "" ? "" : this.selectedProcComponentData.procPart)
  //           && x.procSide === (this.selectedProcComponentData.procSide == "" ? "" : this.selectedProcComponentData.procSide)
  //         // && x.procOther === (this.selectedProcComponentData.procOther == "" ? "" : this.selectedProcComponentData.procOther)
  //       );

  //       if (removeindex1 == -1)
  //         // this.proceduresComponent.splice(0, 0, this.selectedProcComponentData);
  //         this.proceduresComponent.push(this.selectedProcComponentData);

  //       const removeindex = this.patientprocedures.findIndex(
  //         x => x.procType === (this.selectedProcComponentData.procType == "" ? "" : this.selectedProcComponentData.procType)
  //           && x.procedureName === (this.selectedProcComponentData.procedureName == "" ? "" : this.selectedProcComponentData.procedureName)
  //           && x.procPart === (this.selectedProcComponentData.procPart == "" ? "" : this.selectedProcComponentData.procPart)
  //           && x.procSide === (this.selectedProcComponentData.procSide == "" ? "" : this.selectedProcComponentData.procSide)
  //         // && x.procOther === (this.selectedProcComponentData.procOther == "" ? "" : this.selectedProcComponentData.procOther)
  //       );
  //       if (removeindex == -1)
  //         // this.patientprocedures.splice(0, 0, this.selectedProcComponentData);
  //         this.patientprocedures.push(this.selectedProcComponentData);
  //     }


  //     this.dataSource.data = this.proceduresComponent;
  //     this.dataSource3.data = this.patientprocedures;


  // this.dialogRef.close(this.selectedProcComponentData);
  // this.selectedProcComponentData = null;

  // this.ProceduresForm.patchValue({
  //   procType: [''],
  //   procLevels: [''],
  //   // procName:[''],
  //   procPart: [''],
  //   procSide: [''],
  //   procOther: [''],

  // });

  //   }


  onPastProcedureAddClick(pro: IProcedureComponent) {


    var elemtpastPro = this.patientprocedures.filter(
      x => x.procType === (pro.procType == "" ? "" : pro.procType)
        && x.procedureName === (pro.procedureName == "" ? "" : pro.procedureName)
        // && x.procPart === (pro.procPart == "" ? "" : pro.procPart)
        && x.procSide === (pro.procSide == "" ? "" : pro.procSide)
    );
    this.selctedProcedureCode = elemtpastPro[0];

    const removeindexpro = this.proceduresComponent.findIndex(
      x => x.procType === (this.selctedProcedureCode.procType == "" ? "" : this.selctedProcedureCode.procType)
        && x.procedureName === (this.selctedProcedureCode.procedureName == "" ? "" : this.selctedProcedureCode.procedureName)
        //  && x.procPart === (this.selctedProcedureCode.procPart == "" ? "" : this.selctedProcedureCode.procPart)
        && x.procSide === (this.selctedProcedureCode.procSide == "" ? "" : this.selctedProcedureCode.procSide)
      // && x.procOther === (this.selectedProcComponentData.procOther == "" ? "" : this.selectedProcComponentData.procOther)
    );


    var levelArr;
    var othersArr;

    if (this.selctedProcedureCode.procLevels != null && this.selctedProcedureCode.procLevels != "") {
      levelArr = this.selctedProcedureCode.procLevels.split(',');
    }

    if (this.selctedProcedureCode.procOther != null && this.selctedProcedureCode.procOther != "") {
      othersArr = this.selctedProcedureCode.procOther.split(',');
    }

    // if (this.procPartsdata.length > 0) {
    //   var CurParts;
    //   var curpartId;
    //   var Currele = this.procPartsdata.filter((attr: IProcedureParts) => attr.procedureId == this.selctedProcedureCode.procedureId);
    //   CurParts = Currele;
    //   if (Currele.length > 0) {
    //     var elecurpartId = Currele.filter((attr: IProcedureParts) => attr.partName == this.selctedProcedureCode.procPart);
    //     if (elecurpartId.length > 0) {
    //       curpartId = elecurpartId[0].partId;
    //     }
    //   }

    // }

    // var curpartId;

    // curpartId = 1;

    // //if (this.procLevelsdata.length > 0 && curpartId > 0) {
    // if (this.procLevelsdata.length > 0 ) {
    //   var CurLevels;
    //   var elemtlevel = this.procLevelsdata.filter((attr: IprocedureLevels) => attr.procedureId == this.selctedProcedureCode.procedureId && attr.partId == curpartId);
    //   CurLevels = elemtlevel;
    // } 

    var curpartId = 0;
    if (this.selctedProcedureCode.procedureName.includes('Cervical') || this.selctedProcedureCode.procedureName.includes(('Cervical').toLowerCase())) {
      curpartId = 1;
    }
    else if (this.selctedProcedureCode.procedureName.includes('Thoracic') || this.selctedProcedureCode.procedureName.includes(('Thoracic').toLowerCase())) {
      curpartId = 2;
    }
    else if (this.selctedProcedureCode.procedureName.includes('Lumbar') || this.selctedProcedureCode.procedureName.includes(('Lumbar').toLowerCase())) {
      curpartId = 3;
    }


    if (this.procLevelsdata.length > 0 && curpartId > 0) {
      var CurLevels;
      var elemtlevel = this.procLevelsdata.filter((attr: IprocedureLevels) => attr.partId == curpartId);
      CurLevels = elemtlevel;
    }
    else {
      var CurLevels;
      var elemtlevel = this.procLevelsdata;
      CurLevels = elemtlevel;
    }

    this.selctedProcedureCode = {
      procCompId: 0,
      patientId: CommonComponents.patientId,
      encounterId: CommonComponents.encounterId,
      procType: this.selctedProcedureCode.procType,
      procedureId: this.selctedProcedureCode.procedureId,
      procedureName: this.selctedProcedureCode.procedureName,
      procPart: this.selctedProcedureCode.procPart,
      procSide: this.selctedProcedureCode.procSide,
      procLevels: this.selctedProcedureCode.procLevels,
      arrayProcLevels: levelArr,
      procOther: this.selctedProcedureCode.procOther,
      arrayProcOther: othersArr,
      procCPT: this.selctedProcedureCode.procCPT,
      // sorceprocPart: CurParts,
      sorceprocPart: [],
      sourcearrayProcLevels: CurLevels,
      abn: '',
      qty: 1,
      isActive: true,
      createdBy: encodeURIComponent(sessionStorage.getItem("userId")).toString(),
      createdOn: null,
      modifiedBy: '',
      modifiedOn: null,
      isPast: null,
      procedureCPT: this.selctedProcedureCode.procCPT,
      visitDate: null,
      aliasId: null,
      priority: null,
      orASCProcId: this.selctedProcedureCode.orASCProcId,
      procTempId: null,
      dateVisit: '',
      isOR: false,
      categoryId: this.selctedProcedureCode.categoryId
    }

    if (removeindexpro == -1)
      this.proceduresComponent.push(this.selctedProcedureCode);

    if (this.showedit == 0) {
      // const dialogReff = this.dialog.open(PatientProceduresComponent, {
      //   width: '600px',
      //   height: '300px',
      //   data: {
      //     procedureName: this.selctedProcedureCode.procedureName, procSide: this.selctedProcedureCode.procSide
      //     , procType: this.selctedProcedureCode.procType, procLevels: this.selctedProcedureCode.procLevels
      //   }
      // });

      // dialogReff.afterClosed().subscribe(result => {
      //   this.selctedProcedureCode.procLevels = result.procLevels;
      //   this.selctedProcedureCode.procSide = result.procSide;
      //   this.selctedProcedureCode.procType = result.procType;
      //   this.dialogRef.close(this.selctedProcedureCode);
      //   this.selctedProcedureCode = null
      //   this.dataSource.data = this.proceduresComponent;

      // });
      this.dialogRef.close(this.selctedProcedureCode);
      this.selctedProcedureCode = null
      this.dataSource.data = this.proceduresComponent;
    }
    else {
      this.dialogRef.close(this.selctedProcedureCode);
      this.selctedProcedureCode = null
      this.dataSource.data = this.proceduresComponent;

    }
  }

  onPastProcedureAddClick1(pro: IProcedureComponent) {

    var elemtpastPro = this.patientprocedures.filter(
      x => x.procType === (pro.procType == "" ? "" : pro.procType)
        && x.procedureName === (pro.procedureName == "" ? "" : pro.procedureName)
        && x.procPart === (pro.procPart == "" ? "" : pro.procPart)
        && x.procSide === (pro.procSide == "" ? "" : pro.procSide)
    );
    this.selctedProcedureCode = elemtpastPro[0];

    const removeindexpro = this.proceduresComponent.findIndex(
      x => x.procType === (this.selctedProcedureCode.procType == "" ? "" : this.selctedProcedureCode.procType)
        && x.procedureName === (this.selctedProcedureCode.procedureName == "" ? "" : this.selctedProcedureCode.procedureName)
        && x.procPart === (this.selctedProcedureCode.procPart == "" ? "" : this.selctedProcedureCode.procPart)
        && x.procSide === (this.selctedProcedureCode.procSide == "" ? "" : this.selctedProcedureCode.procSide)
      // && x.procOther === (this.selectedProcComponentData.procOther == "" ? "" : this.selectedProcComponentData.procOther)
    );


    var levelArr;
    var othersArr;

    if (this.selctedProcedureCode.procLevels != null) {
      levelArr = this.selctedProcedureCode.procLevels.split(',');
    }
    else {
      levelArr = '';
    }

    if (this.selctedProcedureCode.procOther != null) {
      othersArr = this.selctedProcedureCode.procOther.split(',');
    }

    if (this.procPartsdata.length > 0) {
      var CurParts;
      var curpartId;
      var Currele = this.procPartsdata.filter((attr: IProcedureParts) => attr.procedureId == this.selctedProcedureCode.procedureId);
      CurParts = Currele;
      if (Currele.length > 0) {
        var elecurpartId = Currele.filter((attr: IProcedureParts) => attr.partName == this.selctedProcedureCode.procPart);
        if (elecurpartId.length > 0) {
          curpartId = elecurpartId[0].partId;
        }
      }

    }

    if (this.procLevelsdata.length > 0 && curpartId > 0) {

      var CurLevels;
      var elemtlevel = this.procLevelsdata.filter((attr: IprocedureLevels) => attr.procedureId == this.selctedProcedureCode.procedureId && attr.partId == curpartId);
      CurLevels = elemtlevel;
    }


    this.selctedProcedureCode = {

      procCompId: 0,
      patientId: CommonComponents.patientId,
      encounterId: CommonComponents.encounterId,
      procType: this.selctedProcedureCode.procType,
      procedureId: this.selctedProcedureCode.procedureId,
      procedureName: this.selctedProcedureCode.procedureName,
      procPart: this.selctedProcedureCode.procPart,
      procSide: this.selctedProcedureCode.procSide,
      procLevels: this.selctedProcedureCode.procLevels,
      arrayProcLevels: levelArr,
      procOther: this.selctedProcedureCode.procOther,
      arrayProcOther: othersArr,
      procCPT: this.selctedProcedureCode.procCPT,
      sorceprocPart: CurParts,
      sourcearrayProcLevels: CurLevels,
      abn: '',
      qty: null,
      isActive: true,
      createdBy: encodeURIComponent(sessionStorage.getItem("userId")).toString(),
      createdOn: null,
      modifiedBy: '',
      modifiedOn: null,
      isPast: null,
      procedureCPT: this.selctedProcedureCode.procedureCPT,
      visitDate: null,
      priority: null,
      aliasId: null,
      orASCProcId: this.selctedProcedureCode.orASCProcId,
      procTempId: null,
      dateVisit: '',
      isOR: false,
      categoryId: this.selctedProcedureCode.categoryId
    }

    if (removeindexpro == -1)
      this.proceduresComponent.push(this.selctedProcedureCode);

    if (this.showedit == 0) {
      const dialogReff = this.dialog.open(PatientProceduresComponent, {
        width: '600px',
        height: '300px',
        data: {
          procedureName: this.selctedProcedureCode.procedureName, procSide: this.selctedProcedureCode.procSide
          , procType: this.selctedProcedureCode.procType, procLevels: this.selctedProcedureCode.procLevels
          , procCode: this.selctedProcedureCode.procedureCPT
        }
      });

      dialogReff.afterClosed().subscribe(result => {
        this.selctedProcedureCode.procLevels = result.procLevels;
        this.selctedProcedureCode.procSide = result.procSide;
        this.selctedProcedureCode.procType = result.procType;

        this.dialogRef.close(this.selctedProcedureCode);
        this.selctedProcedureCode = null
        this.dataSource.data = this.proceduresComponent;
      });
    }
    else {
      this.dialogRef.close(this.selctedProcedureCode);
      this.selctedProcedureCode = null
      this.dataSource.data = this.proceduresComponent;
    }
  }

  currentPatientProcedureAddClick(pro: IProcedureComponent) {
    var elemtpastPro = this.previousProcedures.filter(
      x => x.procType === (pro.procType == "" ? "" : pro.procType)
        && x.procedureName === (pro.procedureName == "" ? "" : pro.procedureName)
        // && x.procPart === (pro.procPart == "" ? "" : pro.procPart)
        && x.procSide === (pro.procSide == "" ? "" : pro.procSide)
      //    && x.procCPT === (pro.procCPT == "" ? "" : pro.procCPT)
    );
    this.selctedProcedureCode = elemtpastPro[0];

    const removeindexpro = this.proceduresComponent.findIndex(
      x => x.procType === (this.selctedProcedureCode.procType == "" ? "" : this.selctedProcedureCode.procType)
        && x.procedureName === (this.selctedProcedureCode.procedureName == "" ? "" : this.selctedProcedureCode.procedureName)
        //  && x.procPart === (this.selctedProcedureCode.procPart == "" ? "" : this.selctedProcedureCode.procPart)
        && x.procSide === (this.selctedProcedureCode.procSide == "" ? "" : this.selctedProcedureCode.procSide)
      // && x.procOther === (this.selectedProcComponentData.procOther == "" ? "" : this.selectedProcComponentData.procOther)
    );


    var levelArr;
    var othersArr;

    if (this.selctedProcedureCode.procLevels != null && this.selctedProcedureCode.procLevels != "") {
      levelArr = this.selctedProcedureCode.procLevels.split(',');
    }

    if (this.selctedProcedureCode.procOther != null && this.selctedProcedureCode.procOther != "") {
      othersArr = this.selctedProcedureCode.procOther.split(',');
    }

    var curpartId = 0;
    if (this.selctedProcedureCode.procedureName.includes('Cervical') || this.selctedProcedureCode.procedureName.includes(('Cervical').toLowerCase())) {
      curpartId = 1;
    }
    else if (this.selctedProcedureCode.procedureName.includes('Thoracic') || this.selctedProcedureCode.procedureName.includes(('Thoracic').toLowerCase())) {
      curpartId = 2;
    }
    else if (this.selctedProcedureCode.procedureName.includes('Lumbar') || this.selctedProcedureCode.procedureName.includes(('Lumbar').toLowerCase())) {
      curpartId = 3;
    }


    if (this.procLevelsdata.length > 0 && curpartId > 0) {
      var CurLevels;
      var elemtlevel = this.procLevelsdata.filter((attr: IprocedureLevels) => attr.partId == curpartId);
      CurLevels = elemtlevel;
    }
    else {
      var CurLevels;
      var elemtlevel = this.procLevelsdata;
      CurLevels = elemtlevel;
    }

    this.selctedProcedureCode = {
      procCompId: 0,
      patientId: CommonComponents.patientId,
      encounterId: CommonComponents.encounterId,
      procType: this.selctedProcedureCode.procType,
      procedureId: this.selctedProcedureCode.procedureId,
      procedureName: this.selctedProcedureCode.procedureName,
      procPart: this.selctedProcedureCode.procPart,
      procSide: this.selctedProcedureCode.procSide,
      procLevels: this.selctedProcedureCode.procLevels,
      arrayProcLevels: levelArr,
      procOther: this.selctedProcedureCode.procOther,
      arrayProcOther: othersArr,
      procCPT: this.selctedProcedureCode.procCPT,
      // sorceprocPart: CurParts,
      sorceprocPart: [],
      sourcearrayProcLevels: CurLevels,
      abn: '',
      qty: 1,
      isActive: true,
      createdBy: encodeURIComponent(sessionStorage.getItem("userId")).toString(),
      createdOn: null,
      modifiedBy: '',
      modifiedOn: null,
      isPast: null,
      procedureCPT: this.selctedProcedureCode.procCPT,
      visitDate: null,
      aliasId: null,
      priority: null,
      orASCProcId: this.selctedProcedureCode.orASCProcId,
      procTempId: null,
      dateVisit: '',
      isOR: false,
      categoryId: this.selctedProcedureCode.categoryId
    }

    if (removeindexpro == -1)
      this.proceduresComponent.push(this.selctedProcedureCode);


    // if (this.showedit == 0) {
    //   const dialogReff = this.dialog.open(PatientProceduresComponent, {
    //     width: '600px',
    //     height: '300px',
    //     data: {
    //       procedureName: this.selctedProcedureCode.procedureName, procSide: this.selctedProcedureCode.procSide
    //       , procType: this.selctedProcedureCode.procType, procLevels: this.selctedProcedureCode.procLevels
    //       , procCode: this.selctedProcedureCode.procCPT
    //     }
    //   });

    //   dialogReff.afterClosed().subscribe(result => {
    //     this.selctedProcedureCode.procLevels = result.procLevels;
    //     this.selctedProcedureCode.procSide = result.procSide;
    //     this.selctedProcedureCode.procType = result.procType;
    //     this.dialogRef.close(this.selctedProcedureCode);
    //     this.selctedProcedureCode = null
    //     this.dataSource.data = this.proceduresComponent;

    //   });
    // }
    // else {
    this.dialogRef.close(this.selctedProcedureCode);
    this.selctedProcedureCode = null
    this.dataSource.data = this.proceduresComponent;
    //}
  }


  // onSelectProcDeleteClick(element: IProcedureComponent) {
  //   // alert("category clicked" + categoryCodeId);   

  //   const message = "Are you sure to delete procedure from selected encounter? ";
  //   const dialogData = new ConfirmDialogModel('Confirm Action', message);
  //   const dialogRef = this.dialog.open(DeleteDocumentComponent, {
  //     maxWidth: '400px',
  //     data: dialogData
  //   });

  //   dialogRef.afterClosed().subscribe(dialogResult => {
  //     this.result = dialogResult;
  //     if (this.result) {

  //       var delid = element.procCompId;
  //       // var delIcd = element.icdCode;

  //       if (delid == 0) {
  //         const removeindexdelete = this.proceduresComponent.findIndex(x => x.procedureName === element.procedureName && x.procPart === element.procPart && x.procCPT === element.procCPT);
  //         if (removeindexdelete != -1)
  //           this.proceduresComponent.splice(removeindexdelete, 1);

  //           const removeindexdelete1 = this.patientprocedures.findIndex(x => x.procedureName === element.procedureName && x.procPart === element.procPart && x.procCPT === element.procCPT &&  x.isPast != true);
  //           if (removeindexdelete1 != -1)
  //             this.patientprocedures.splice(removeindexdelete1, 1);
  //       }


  //       // const removeindexdelete1 = this.patientprocedures.findIndex(x => x.procedureName === element.procedureName && x.procPart === element.procPart && x.procCPT === element.procCPT);
  //       // if (removeindexdelete1 != -1)
  //       //   this.patientprocedures.splice(removeindexdelete1, 1);


  //       if (delid > 0) {
  //         // var encid = CommonComponents.encounterId;
  //         const removeindexproc = this.proceduresComponent.findIndex(x => x.procCompId === delid);
  //         if (removeindexproc != -1)
  //           this.proceduresComponent.splice(removeindexproc, 1);
  //         this.proService.DeleteSelectProcedureInfo(delid).subscribe(
  //           results => {
  //             this.result = results;
  //             if (CommonComponents.encounterId && CommonComponents.patientId) {
  //               this.getProceduresInfo(CommonComponents.encounterId, CommonComponents.patientId);               
  //               this.getAllCurrentProceduresInfoById(CommonComponents.encounterId, CommonComponents.patientId);          
  //             }
  //             this.toastr.success(this.result);
  //           });
  //       } else {
  //         this.dataSource.data = this.proceduresComponent;
  //         this.dataSource3.data = this.patientprocedures;
  //         this.toastr.success("Procedure details delete successfully");
  //       }

  //       // this.dataSource.data = this.proceduresComponent;
  //       // this.dataSource3.data = this.patientprocedures;

  //     } else {
  //       this.result = dialogResult;
  //     }
  //   });

  // }

  // onSelectAllPatProcDeleteClick(element: IProcedureComponent) {
  //   // alert("category clicked" + categoryCodeId);   

  //   const message = "Are you sure to delete procedure from selected encounter? ";
  //   const dialogData = new ConfirmDialogModel('Confirm Action', message);
  //   const dialogRef = this.dialog.open(DeleteDocumentComponent, {
  //     maxWidth: '400px',
  //     data: dialogData
  //   });

  //   dialogRef.afterClosed().subscribe(dialogResult => {
  //     this.result = dialogResult;
  //     if (this.result) {

  //       var delid = element.procCompId;
  //       // var delIcd = element.icdCode;

  //       // if (delid == 0) {
  //       // const removeindexdelete =  this.proceduresComponent.findIndex(x => x.procedureName === element.procedureName && x.procPart === element.procPart && x.procCPT === element.procCPT);
  //       // if (removeindexdelete != -1)
  //       //   this.proceduresComponent.splice(removeindexdelete, 1);
  //       // }

  //       if (delid == 0) {
  //         const removeindexdelete1 = this.patientprocedures.findIndex(x => x.procedureName === element.procedureName && x.procPart === element.procPart && x.procCPT === element.procCPT);
  //         if (removeindexdelete1 != -1)
  //           this.patientprocedures.splice(removeindexdelete1, 1);
  //       }


  //       if (delid > 0) {
  //         // var encid = CommonComponents.encounterId;
  //         const removeindexproc = this.patientprocedures.findIndex(x => x.procCompId === delid);
  //         if (removeindexproc != -1)
  //           this.patientprocedures.splice(removeindexproc, 1);
  //         this.proService.DeleteSelectAllPatProcedureInfo(delid).subscribe(
  //           results => {
  //             this.result = results;
  //             this.toastr.success(this.result);
  //           });
  //       } else {
  //         this.toastr.success("Procedure details delete successfully");
  //       }

  //       // this.dataSource.data = this.proceduresComponent;
  //       this.dataSource3.data = this.patientprocedures;

  //     } else {
  //       this.result = dialogResult;
  //     }
  //   });

  // }

  oncellclick(element) {
    this.selectedRowIndex = element.categoryIcdId;

  }

  // oncategoryclick(element) {

  //   this.oncategoryIndex = element.categoryId;
  // }

  oncategoryclick(element) {

    //this.ischkUnchkVisitProc = false;
    // this.ischkUnchk = false;
    // this.IsCheckedProcedures = false;
    // //this.onChange(this.ischkUnchk);
    // //  this.currentVisitNoteProcedures(this.ischkUnchkVisitProc)
    // this.IsCheckedProcedures = false;
    // //this.VisitNoteProcedures = false;

    // let searchValue = this.ProceduresForm.value.searchTerm;
    // if (element.categoryId == 2) {
    //   this.dataSource3.data = this.onPatientProcSearchClick(searchValue);
    // }
    //  else if (this.isPreviousProcSearch && this.ischkUnchk) {
    //   this.dataSource4.data = this.onPreviousPatientProcSearchClick(searchValue);
    // } else {
    //   this.dataSource2.data = this.onProcedureSearcClick(searchValue);

    // }
    // this.visitNoteProceduresdataSource.data = this.ProcSearchClickVisitNoteProcedure(searchValue);
    $(".tbl-scroll").scrollTop(0);
    this.oncategoryIndex = element.categoryId;
    this.searchResults = "";
    this.hidePagination = false;
    // alert(element.categoryId)
  }



  onProcedureSubmit() {
    //if(this.ProceduresForm.touched)
    // {
    if (this.saveflag == true) {
      this.saveflag = false;
      this.mapFormValuesProcedureModel();
      this.proService.addProcedureInfo(this.addProcComponent).subscribe(
        results => {
          this.result = results;
          if (CommonComponents.encounterId && CommonComponents.patientId) {
            this.getProceduresInfo(CommonComponents.encounterId, CommonComponents.patientId);
            this.getAllCurrentProceduresInfoById(CommonComponents.encounterId, CommonComponents.patientId);
          }
          this.toastr.success(this.result);
        }
      );
    }
    // }
  }

  mapFormValuesProcedureModel() {

    this.addProcComponent = {
      EncProcedures: this.proceduresComponent,
      PatAllProcedures: this.patientprocedures
    }
  }

  dropTable(event: CdkDragDrop<IProcedureComponent[]>) {
    const prevIndex = this.dataSource.data.findIndex((d) => d === event.item.data);
    moveItemInArray(this.dataSource.data, prevIndex, event.currentIndex);
    this.table.renderRows();
    // this.dataSource.data = clonedeep(this.dataSource.data);
  }


  tabChanged() {
    // this.onProcedureSubmit();
  }

  public IsCheckedProcedures: boolean = false;
  public isPreviousProcSearch: boolean = false;
  public ischkUnchk: boolean = false;
  //public ischkUnchkVisitProc: boolean = false;
  onChange(event) {
    // alert("showall");
    //this.ischkUnchkVisitProc = event.checked;
    //this.ischkUnchkVisitProc = !this.ischkUnchk;

    this.hidePagination = true;
    this.ProceduresForm.patchValue({
      searchTerm: '',
    });
    this.searchResults = '';
    if (event.checked) {

      //this.ischkUnchkVisitProc = false;
      this.IsCheckedProcedures = true;
      this.IsPatientProcedures = false;
      this.IsAllProcedures = false;
      this.ischkUnchk = false;
      this.oncategoryIndex = -1;
      this.selectProcCategory = -1;
      this.GetAllPreviousPatProcDetails(CommonComponents.patientId);
      this.isPreviousProcSearch = true;
      //this.currentVisitNoteProcedures(this.ischkUnchkVisitProc);

    } else {
      //this.ischkUnchkVisitProc = false;
      this.IsCheckedProcedures = false;
      this.IsPatientProcedures = true;
      this.IsAllProcedures = false;
      this.ischkUnchk = false;
      this.oncategoryIndex = 2;
      this.selectProcCategory = 2;
      this.isPreviousProcSearch = false;
      this.getAllCurrentProceduresInfoById(CommonComponents.encounterId, CommonComponents.patientId);
      //this.currentVisitNoteProcedures(this.ischkUnchkVisitProc);
    }
  }
  previousProcedures: IProcedureComponent[] = [];

  GetAllPreviousPatProcDetails(patId: number) {
    this.proService.getPreviousPatProcedures(patId)
      .subscribe(
        (patPreviousInfo: IProcedureComponent[]) => {
          this.previousProcedures = patPreviousInfo;
          this.dataSource4.data = this.previousProcedures;
          this.dataSource4.filterPredicate = this.createFilter();
          this.dataSource4.paginator = this.paginator;
          this.dataSource4.sort = this.sort;
          this.spinner.hide();
        },
        (err: any) => {
          console.log(err);
          this.spinner.hide();
        });
  }

  createFilter(): (data: any, filter: string) => boolean {
    let filterFunction = function (data, filter): boolean {
      let searchTerms = JSON.parse(filter);

      return (data.dateVisit === null ? "" : data.dateVisit).toString().toLowerCase().indexOf(searchTerms.dateVisit) !== -1
        && (data.procType === null ? "" : data.procType).toString().toLowerCase().indexOf(searchTerms.type.toLowerCase()) !== -1
        && (data.procSide === null ? "" : data.procSide).toString().toLowerCase().indexOf(searchTerms.side.toLowerCase()) !== -1
        && (data.procedureName === null ? "" : data.procedureName).toString().toLowerCase().indexOf(searchTerms.procedureName.toLowerCase()) !== -1
        && (data.procLevels === null ? "" : data.procLevels).toString().toLowerCase().indexOf(searchTerms.levels.toLowerCase()) !== -1
        && (data.procOther === null ? "" : data.procOther).toString().toLowerCase().indexOf(searchTerms.others.toLowerCase()) !== -1
        && (data.procCPT === null ? "" : data.procCPT).toString().toLowerCase().indexOf(searchTerms.cptCode.toLowerCase()) !== -1
        && (data.qty === null ? "" : data.qty).toString().toLowerCase().indexOf(searchTerms.qty.toString()) !== -1
    }
    return filterFunction;
  }

  // currentVisitNoteProcedures(event) {
  //   this.ischkUnchk = event.checked;
  //   this.ischkUnchk = !this.ischkUnchkVisitProc;
  //   if (event.checked) {
  //     this.ischkUnchkVisitProc = true;
  //     this.ischkUnchk = false;
  //     this.VisitNoteProcedures = true;
  //     this.IsPatientProcedures = false;
  //     this.IsAllProcedures = false;
  //     this.IsCheckedProcedures = false;
  //    // this.getProceduresInfo(CommonComponents.encounterId, CommonComponents.patientId);
  //     this.loadProceduresTypesdata();
  //   } else {
  //     this.ischkUnchk = false;
  //     this.ischkUnchkVisitProc = false;
  //     this.VisitNoteProcedures = false;
  //     // this.IsPatientProcedures = true;
  //      this.IsAllProcedures = true;
  //     // this.IsCheckedProcedures = true;
  //     this.loadAllFormProceduresdata();

  //   }


  // }
  checkProcedurelist: IProcedureComponent[] = [];
  checkVisitNoteProcedures(event: MatCheckboxChange, ele: IProcedureComponent): void {
    if (event.checked) {
      this.checkProcedurelist.push(ele)
    } else {
      this.checkProcedurelist = this.checkProcedurelist.filter(a => a !== ele);
    }
  }
  AddcurrentVisitNoteProceduresOrRecord() {
    this.dialogRef.close(this.checkProcedurelist);
  }

  AddcurrentVisitNoteCancel() {
    this.dialogRef.close();
  }

  //pagination Work







}
